import LocationSearchBar from "../navBar/locationSearchBar";
import "../navBar/locationSearchBar.scss";
import "./HomePage.scss";
import "../navBar/navBar.scss";
import { useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ImLocation } from "react-icons/im";
import { IoRestaurantOutline } from "react-icons/io5";
import { MdPayment } from "react-icons/md";
import { FaCircle } from "react-icons/fa";
import jwt_decode from "jwt-decode";

function HomePage() {
  const locationSeleced = useSelector((state) => state.userReducer);
  const [response, setResponse] = useState(false);
  const navigate = useNavigate();
  const [userManual, setUserManual] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    console.log(locationSeleced);
    if (token) {
      const decodedToken = jwt_decode(token);
      if (decodedToken.role === "superadmin") {
        console.log("superadmin");
        navigate("/admin/adminDashboard");
      } else if (decodedToken.role === "user") {
        navigate("/restaurants");
      }
    } else {
      navigate("/");
      const addressInput = document.getElementById("navbar-address");
      addressInput.value = "";
    }
  }, []);

  const navigateToLogIn = () => {
    navigate("/logIn");
  };
  const navigateToRegisterUser = () => {
    navigate("/user/creatuser");
  };

  const navigateTorestaurants = () => {
    if (locationSeleced.address.label !== "") {
      navigate("/restaurants");
    } else {
      setResponse(true);
    }
  };
  const onCancel = () => {
    setUserManual(false);
  };

  return (
    <div className="HomePage-container">
      <div className="page-one">
        <div className="addressConfirmation-container">
          <div className="Login-signUp-buttons">
            <div className="Login-button" onClick={navigateToLogIn}>
              LogIn
            </div>
            <div className="signUp-button" onClick={navigateToRegisterUser}>
              Create New Account
            </div>
          </div>
          <div className="addressConfirmation">
            <h1>Time To Order Homemade Food To Your Door</h1>
            <div className="address-enter">
              <LocationSearchBar autofocusProp={true} />

              <button onClick={navigateTorestaurants}>Enter</button>
            </div>
            {response && <div style={{ color: "red" }}>Invalid address</div>}
          </div>
        </div>
        <div className="svg-container">
          <svg width="100%" viewBox="0 0 500 100">
            <path
              d="M 0 50 C 150 150 300 0 500 80 L 500 0 L 0 0"
              fill="#9a7f41"
            ></path>
            <path
              d="M 0 50 C 150 150 305 -8 500 75 L 500 0 L 0 0"
              fill="#edc669"
            ></path>
            <path
              d="M 0 50 C 215 150 250 0 500 100 L 500 0 L 0 0"
              fill="#edc669"
              opacity="0.6"
            ></path>
          </svg>
        </div>
      </div>
      <div className="page-two">
        <div className="steps-order">
          <h1>Steps To Order</h1>
          <div className="steps-container">
            <div className="steps-item">
              <ImLocation className="icon" />
              <div className="item-text">
                <h2>Provide your location</h2>
                <p>Fill out your address.</p>
              </div>
            </div>
            <div className="steps-item">
              <IoRestaurantOutline className="icon" />
              <div className="item-text">
                <h2>Choose your restaurant and food</h2>
                <p>
                  What are you in the mood for?
                  <br /> Browse through many restaurants and cuisines.
                </p>
              </div>
            </div>
            <div className="steps-item">
              <MdPayment className="icon" />
              <div className="item-text">
                <h2>Pay and Pickup or get delivered your food</h2>
                <p>
                  Pay using various payment methods.
                  <br /> That's it, bon appétit!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="benefits-container">
          <h1>Your Benefits</h1>
          <div className="benefits-items">
            <div className="benefits-item">
              <FaCircle className="icon-benefits" />
              <p>
                Explore diverse homemade dishes from different cuisines and
                talented local chefs
              </p>
            </div>
            <div className="benefits-item">
              <FaCircle className="icon-benefits" />
              <p>
                Enjoy the convenience of browsing and ordering homemade meals
                from home
              </p>
            </div>
            <div className="benefits-item">
              <FaCircle className="icon-benefits" />
              <p>
                Skip the cooking hassle and enjoy a homemade meal without
                spending time in the kitchen
              </p>
            </div>
            <div className="benefits-item">
              <FaCircle className="icon-benefits" />
              <p>Enjoy browsing and ordering homemade meals from home</p>
            </div>
          </div>
        </div>
      </div>
      {userManual && (
        <div className="user-manual-container">
          <div className="user-manual">
            <p className="boldText"> 1. User Not Logged In Yet:</p> <br />
            <div className="user-manual-item-text">
              Enter your address to find nearby restaurants. <br />
              Browse restaurants and their menus. <br />
              Add dishes to your order. <br />
              Log in to confirm the order and choose payment method.
              <br />
            </div>
            <br />
            <p className="boldText"> 2. User Logged In: </p>
            <br />
            <div className="user-manual-item-text">
              Access personalized features like order history and profile
              editing.
              <br /> Receive notifications about order status.
              <br /> Rate restaurants and add favorites.
              <br /> Filter restaurants by rating, delivery time, and category.{" "}
              <br />
            </div>
            <br />
            <p className="boldText">3. New User Registration:</p>
            <div className="user-manual-item-text">
              <br /> Sign up by providing profile information. <br />
              Confirm email and address. <br />
              Enjoy personalized features after login. <br />
            </div>
            <br />
            <p className="boldText">4. Adding Homemade Restaurant:</p>
            <div className="user-manual-item-text">
              <br /> Fill out the restaurant creation form. <br />
              Upload cover image and menu items. <br />
              Save edits and manage restaurant settings.
            </div>
            <br />
            <button type="button" onClick={onCancel}>
              Cancel
            </button>
          </div>
        </div>
      )}
      <div className="footer">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#CCAA59"
            fillOpacity="1"
            d="M0,0L1440,96L1440,320L0,320Z"
          ></path>
          <text
            x="50%"
            y="80%"
            dominantBaseline="middle"
            textAnchor="middle"
            fill="black"
            fontSize="18"
            onClick={() => setUserManual(true)}
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            User Manual
          </text>
          <text
            x="50%"
            y="90%"
            dominantBaseline="middle"
            textAnchor="middle"
            fill="black"
            fontSize="18"
          >
            &copy; Benarab Badiazamane. All Rights Reserved
          </text>
        </svg>
      </div>
    </div>
  );
}

export default HomePage;
